import React from "react";
import { FaTimes } from "react-icons/fa";

const EnquiryDetailsModal = ({ isOpen, onClose, inquiry }) => {
  if (!isOpen || !inquiry) return null;

  // ✅ Split subject into ISO & Compliance categories
  const parseCertificates = (subject) => {
    const result = { ISO: [], Compliance: [] };
    if (!subject) return result;

    const parts = subject.split("|").map((s) => s.trim());
    parts.forEach((part) => {
      if (part.startsWith("ISO:")) {
        result.ISO = part
          .replace("ISO:", "")
          .split(",")
          .map((c) => c.trim());
      } else if (part.startsWith("Compliance:")) {
        result.Compliance = part
          .replace("Compliance:", "")
          .split(",")
          .map((c) => c.trim());
      }
    });
    return result;
  };

  const certificates = parseCertificates(inquiry.subject);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white w-full max-w-xl rounded-2xl shadow-2xl relative p-6 animate-fadeIn">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 p-2 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-100 transition"
        >
          <FaTimes size={18} />
        </button>

        {/* Header */}
        <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b pb-3 text-center">
          Enquiry Details
        </h2>

        {/* Info Section */}
        <div className="space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="bg-gray-50 p-3 rounded-lg shadow-sm">
              <p className="text-xs text-gray-500">Name</p>
              <p className="font-semibold text-gray-800">{inquiry.name}</p>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg shadow-sm">
              <p className="text-xs text-gray-500">Mobile</p>
              <p className="font-semibold text-gray-800">{inquiry.mobile}</p>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg shadow-sm">
              <p className="text-xs text-gray-500">Email</p>
              <p className="font-semibold text-gray-800">
                {inquiry.email || "N/A"}
              </p>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg shadow-sm">
              <p className="text-xs text-gray-500">Status</p>
              <span
                className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${
                  inquiry.status.toLowerCase() === "pending"
                    ? "bg-yellow-100 text-yellow-700"
                    : inquiry.status.toLowerCase() === "completed"
                    ? "bg-green-100 text-green-700"
                    : "bg-blue-100 text-blue-700"
                }`}
              >
                {inquiry.status}
              </span>
            </div>
          </div>

          {/* Certificates Section */}
          <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
            <p className="text-xs text-gray-500 mb-2">Certificates</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {certificates.ISO.length > 0 && (
                <div>
                  <h4 className="font-semibold text-gray-700 mb-1">ISO</h4>
                  <ul className="list-disc list-inside text-sm text-gray-600 space-y-1">
                    {certificates.ISO.map((iso, idx) => (
                      <li key={idx}>{iso}</li>
                    ))}
                  </ul>
                </div>
              )}
              {certificates.Compliance.length > 0 && (
                <div>
                  <h4 className="font-semibold text-gray-700 mb-1">
                    Compliance
                  </h4>
                  <ul className="list-disc list-inside text-sm text-gray-600 space-y-1">
                    {certificates.Compliance.map((comp, idx) => (
                      <li key={idx}>{comp}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>

          {/* Dates */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* Date */}
            <div className="bg-gray-50 p-3 rounded-lg shadow-sm">
              <p className="text-xs text-gray-500">Date</p>
              <p className="font-medium text-gray-800">
                {new Date(inquiry.createdAt).toLocaleDateString()}
              </p>
            </div>

            {/* Time */}
            <div className="bg-gray-50 p-3 rounded-lg shadow-sm">
              <p className="text-xs text-gray-500">Time</p>
              <p className="font-medium text-gray-800">
                {new Date(inquiry.createdAt).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnquiryDetailsModal;
